import { GroupAuthorization } from "./groups.model";

export class UserLogged{
    userAuthorizations?: GroupAuthorization[];
    username? : string;
    name?:string;
    surname?: string;
    millId?: number
    officeId?: number;
    language ?:string;
    dateFormat ?:string;
    configuration?: string;
    token?:string;
}